/** The part of a TinyMCE `AstNode` the image filter needs. */
export interface ImageNodeLike {
	attr: (name: string) => string | null | undefined;
	remove: () => void;
}

const DATA_URI = /^\s*data:/i;

/**
 * TinyMCE parser node filter (register with `editor.parser.addNodeFilter("img", …)`)
 * that removes inline base64 images and keeps hosted ones.
 *
 * A `data:` image is stored in the HTML itself, so one pasted logo can push a sender
 * signature — which `campaignConfig` carries for every sender — past the API body
 * limit (413), and Gmail/Outlook block it anyway. A hosted `https://` image is a
 * short URL and is what every signature generator produces (PREC-4235).
 */
export const dropDataUriImages = (nodes: ImageNodeLike[]): void => {
	for (const node of nodes) {
		if (DATA_URI.test(node.attr("src") ?? "")) {
			node.remove();
		}
	}
};
